import React, { useContext, useState } from 'react';
import MainAppContext from '../../../../../../MainAppContext';

import { Col, Row } from 'react-bootstrap';
import ChartOriginal from '../../_ComponentTypes/Chart/ChartOriginal';
import Simple from '../../_ComponentTypes/Dataserie/Simple';
import SimpleColorList from '../../_ComponentTypes/Dataserie/SimpleColorList';
import SimpleDetailed from '../../_ComponentTypes/Dataserie/SimpleDetailed';
import ListSimple from '../../_ComponentTypes/Dataserie/ListSimple';
import ListTemplate from '../../../../../Templates/List';
import { IconButton } from '@fluentui/react';
import ChangeComponentType from '../../_ComponentTypes/Dataserie/ChangeComponentType';
import SidePanelAddDataserieVariableValue from './SidePanelAddDataserieVariableValue';
import SidePanelEditDataserieVariableValue from './SidePanelEditDataserieVariableValue';
import SidePanelDeleteDataserieVariableValue from './SidePanelDeleteDataserieVariableValue';

import { useTranslation } from 'react-i18next';
import { getBoardVariableDataSerieValues } from '../../../../../../services/sKPI/dataserie.service';
import { updateBoardCompoenet } from '../../../../../../services/sKPI/board.service';
import { enum__ComponentType, __enum_ChartDataserieInputType } from '../../../../../../common/Dictionaries';
import moment from 'moment';
import PropTypes from 'prop-types';
import "./style.css"
import SidePanelViewDataserieAditionalInfo from './SidePanelViewDataserieAditionalInfo';
import BoardAppContext from '../../../../../../BoardAppContext';
import { useDispatch, useSelector } from 'react-redux';
import { action_setBoardDataseries, action_updateComponentInfoDataCompare, action_updateBoardFullStructure, action_updateComponentInfoData, action_updateComponentInfoDataChartCompare } from '../../../../../../reducers/actions/KPI/actions';
import { __KPIAgregations } from '../../../../../../common/Dictionaries';
import { __KPIPeriods } from '../../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import ChartOriginalMiniNew from '../../_ComponentTypes/Chart/ChartOriginalMiniNew';
import { isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import SidePanelDataserieClose from '../../BoardElementTypeBox/DataserieClose/SidePanelDataserieClose';
import SidePanelViewDataserieVariableValue from './SidePanelViewDataserieVariableValue';

function BoardList(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    const { _boardStructureGeneric: boardStructureGeneric } = useSelector((state) => state.boardViewScope);
    const { _componentInfoData, _componentInfoToCompareData } = useSelector((state) => state.chartDataBoard);
    const { _boardElements: boardElements } = useSelector((state) => state.boardViewScope);
    
    const dispatch = useDispatch();

    const { 
        inputParam_BoardId = null,
        inputParam_ElementId = null,
        inputParam_HidePanels = false,
        inputParam_DataserieList = null,
        setBoardVariableDataserieValues = null,
        inputParam_ContainerComponent= null
    } = props;

    const [inputParam_ComponentsAux, setInputParam_ComponentsAux] = useState(__OBJECT_STRUCTURE_GetList(inputParam_DataserieList.length, inputParam_DataserieList));

    const [isCloseDataseriesPanelOpen, setIsCloseDataseriesPanelOpen] = useState(false);
    const [isViewDataserieVariableValuePanelOpen, setIsViewDataserieVariableValuePanelOpen] = useState(false);
    const [isAddDataserieVariableValuePanelOpen, setIsAddDataserieVariableValuePanelOpen] = useState(false);
    const [isEditDataserieVariableValuePanelOpen, setIsEditDataserieVariableValuePanelOpen] = useState(false);
    const [isDeleteDataserieVariableValuePanelOpen, setIsDeleteDataserieVariableValuePanelOpen] = useState(false);
    const [isViewDataserieInfoPanelOpen, setIsViewDataserieInfoPanelOpen] = useState(false);
    
    const [selectedDataserieToPanel, setSelectedDataserieToPanel] = useState(inputParam_DataserieList !== null && inputParam_DataserieList.length > 0 ? inputParam_DataserieList[0] : null);
    const [calendarType, setCalendarType] = useState(null);
    
    const onOpenPanel = (type, calendarType, dataSerie) => {
        switch (type) {
            case "view":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(true)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "view2":
                setIsViewDataserieVariableValuePanelOpen(true)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "add":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(true)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "edit":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(true)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "delete":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(true)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "close":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(true)
                break;
            default:
                break;
        }

        setSelectedDataserieToPanel(dataSerie)
    
        if (type !== "view") {
            setCalendarType(calendarType)
        }
    };

    const onChangeRowDisplayType = (_type, _component) => {
        let error = false;
        _component.componentTypeId = _type;
        boardStructureGeneric[0].l_structure[0].l_container.forEach(container => {
            container.l_components.forEach(component => {
                if (component.id === _component.id) {
                    component.componentTypeId = _type;
                }
            });
        });

        updateBoardCompoenet(_component, _component.id).then((response) => {  
            if (error === false && response.data.succeeded) { 
                dispatch(action_updateBoardFullStructure(boardStructureGeneric[0].l_structure))
            }
            else {
                //ERROR
            }
        }).catch((e) => {
            error = true;
        });
        
        if (error === false) {        
            dispatch(action_updateBoardFullStructure(boardStructureGeneric[0].l_structure))
        }
    };

    const onChangeRowAggregationTime = (defaultAggregation, elementId, dataserieId) => {
        let calendarFilterStartDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate !== null ?
        moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MM/DD/YYYY') : null;

        let calendarFilterEndDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate !== null ?
        moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).format('MM/DD/YYYY') : null;
        
        let calendarFilterSelectorId = contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId;

        getBoardVariableDataSerieValues(inputParam_BoardId, elementId, dataserieId, calendarFilterSelectorId, defaultAggregation ? 2 : 1, calendarFilterStartDate, calendarFilterEndDate).then((response) => {   
            let dataSerieList = inputParam_DataserieList

            for (let index = 0; index < dataSerieList.length; index++) {
                const dataSerie = dataSerieList[index];

                if(dataSerie.dataserieId === dataserieId) {
                    dataSerie.l_vals = response.data.data[0].l_vals;
                    dispatch(action_setBoardDataseries(dataSerieList));
                }
            }
        }).catch((e) => {

        });
    };

    const onChartDataBindClick = (item, chartDataserieInputType) => {
        switch (chartDataserieInputType) {
            case __enum_ChartDataserieInputType.SINGLE:
                setSelectedDataserieToPanel(item)

                dispatch(action_updateComponentInfoData(item, true));

                onChartDataBindClearCompareClick()
                break;
            case __enum_ChartDataserieInputType.MULTIPLE:
                //##Se podria comparar la serie seleccionada de manera normal con la a comparar, si son iguales alertar que no se puede comparar una serie con sigo misma.
                dispatch(action_updateComponentInfoDataCompare(item, true))
                break;
            default:
                break;
        }
    }

    const onChartDataBindClearCompareClick = () => {
        dispatch(action_updateComponentInfoDataChartCompare(null, null, false))
    }

    return (
        <>
            <ListTemplate
                manipulateLocalData={ true }
                className={"display-none no-compact-list"}
                showHeaders={false}
                isHeaderVisible={false}
                listLocalStoragePageSizeVariableName="messageTree"
                data={ (inputParam_ComponentsAux !== null ? inputParam_ComponentsAux : []) }
                setData={ setInputParam_ComponentsAux }
                columns={ (inputParam_ComponentsAux.data !== null) ? [
                    {
                        key: 'name',
                        name: t('data-lang-lbl-name'),
                        fieldName: 'name',
                        minWidth: 250,
                        maxWidth: 250,
                        onRender:(item) => {
                            let itemComponentStructure = inputParam_DataserieList.find(x => x.dataserieId === item.dataserieId)
                            let elementHtmlColor = boardElements.find(x => x.elementId === itemComponentStructure.elementId)

                            let controlMain = null;
                            const controlTools =    
                                                <>
                                                {
                                                    !inputParam_HidePanels &&
                                                    <Col className='col-auto d-flex px-1 mx-1'>
                                                        <ChangeComponentType
                                                            inputParam_OnChangeRowDisplayType={onChangeRowDisplayType}
                                                            inputParam_OnChangeRowAggregationTime={onChangeRowAggregationTime}
                                                            inputParam_OnOpenPanel={onOpenPanel}
                                                            inputParam_Component={item}
                                                            inputParam_DataSerie={itemComponentStructure}
                                                            inputParam_OnSelectSerieToCompareOnChart={onChartDataBindClick}
                                                            inputParam_OnChartDataBindClearCompareClick={onChartDataBindClearCompareClick}
                                                            inputParam_SelectedDataserieToPanel={selectedDataserieToPanel}
                                                            inputParam_HideAggregationButtons={false}
                                                        />
                                                        {
                                                            item && inputParam_ContainerComponent.componentTypeId !== enum__ComponentType.CHART && _componentInfoToCompareData === null &&
                                                            <IconButton
                                                                iconProps={{ iconName: `${ itemComponentStructure.dataserieId === (_componentInfoData !== null ? _componentInfoData.dataserieId : 0) ? 'DrillDownSolid' : "DrillDown" }` }}
                                                                onClick={() => onChartDataBindClick(itemComponentStructure, __enum_ChartDataserieInputType.SINGLE)}
                                                                styles={{ root: {transform: "rotate(-90deg)"}, icon: { fontSize: 20 } }}
                                                            />
                                                        }
                                                        {
                                                            item && inputParam_ContainerComponent.componentTypeId !== enum__ComponentType.CHART && _componentInfoToCompareData !== null && _componentInfoData !== null && 
                                                            <IconButton
                                                                style={{ color: `${ itemComponentStructure.dataserieId === _componentInfoToCompareData.dataserieId ? "#69AA00" : "" }`}}
                                                                iconProps={{ iconName: `${ (itemComponentStructure.dataserieId === _componentInfoToCompareData.dataserieId || itemComponentStructure.dataserieId === _componentInfoData.dataserieId) ? 'DrillDownSolid' : "DrillDown" }` }}
                                                                onClick={() => onChartDataBindClick(itemComponentStructure, __enum_ChartDataserieInputType.SINGLE)}
                                                                styles={{ root: {transform: "rotate(-90deg)"}, icon: { fontSize: 20 } }}
                                                            /> 
                                                        }
                                                    </Col>
                                                }
                                                </>

                            if (itemComponentStructure !== null && item !== undefined) {
                                switch (inputParam_ContainerComponent.componentTypeId) {
                                    case enum__ComponentType.LIST:
                                        controlMain = <>{ controlTools } 
                                            <Row data-dataserie-id={itemComponentStructure.dataserieId} className=' my-3'>
                                                <ListSimple
                                                    inputParam_Item={itemComponentStructure}
                                                    inputParam_ItemFields={contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field)}
                                                />
                                            </Row></>
                                        break;
                                    case enum__ComponentType.CHART:
                                        controlMain = <>{ controlTools } 
                                            <Row>
							                    <Col>
                                                    <ChartOriginalMiniNew inputParam_ComponentContent={itemComponentStructure} />
							                    </Col>
                                            </Row></>
                                        break;
                                    case enum__ComponentType.SIMPLELIST:
                                        controlMain = <>{ controlTools } 
                                            <Row>
                                                <Simple
                                                    inputParam_Item={itemComponentStructure}
                                                    inputParam_ItemFields={contextSite.kpiModule.boardDataserieDisplayFields.value}
                                                />
                                            </Row></>
                                        break;
                                    case enum__ComponentType.SIMPLEDETAILEDLIST:
                                        controlMain = <>{ controlTools } 
                                            <Row>
                                                <SimpleDetailed
                                                    inputParam_Item={itemComponentStructure}
                                                    inputParam_ItemFields={contextSite.kpiModule.boardDataserieDisplayFields.value} />
                                            </Row></>
                                        break;
                                    case enum__ComponentType.SIMPLECOLORLIST:
                                        controlMain = <>{ controlTools }
                                            <Row>
                                                <SimpleColorList
                                                    inputParam_Item={itemComponentStructure}
                                                    inputParam_ItemFields={contextSite.kpiModule.boardDataserieDisplayFields.value} />
                                            </Row></>
                                        break;
                                    default:
                                        controlMain = <div>Seleccionar tipo de despliegue.</div>
                                        break;
                                }
                            }
                            
                            return  <div data-dataserie-id={itemComponentStructure.dataserieId} className={`h-1006 w-100 p-1`}>
                                        <div className='px-1'>
                                            <Row  className='border-end border-top border-bottom rounded-1' style={{whiteSpace: "break-spaces", borderLeft: `20px solid ${ !isNullUndefinedOrEmpty(elementHtmlColor) ? elementHtmlColor.htmlColor : 'white'}`}}>
                                                <Col>
                                                    <Row>
                                                        <Col className='d-flex'>
                                                            <div style={{fontSize: "14px"}}><b>{itemComponentStructure.variableName}</b></div> <div className='pt-1' style={{fontSize: "smaller"}}><b> ({itemComponentStructure.um})</b></div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className='d-flex'>
                                                            <div style={{fontSize: "11px"}}><b>{t('data-lang-lbl-timeaggregation')}: </b> {
                                                                __KPIAgregations.find(x => x.key === itemComponentStructure.timeAggregationId) !== undefined ?
                                                                    t(__KPIAgregations.find(x => x.key === itemComponentStructure.timeAggregationId).title) :
                                                                    t('data-lang-nodata')
                                                            }</div>
                                                            <div className='ps-3' style={{fontSize: "11px"}}><b>{t('data-lang-lbl-isaggregated')}: </b> {
                                                                itemComponentStructure.isAggregate === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')
                                                            }</div>
                                                            <div className='ps-3' style={{fontSize: "11px"}}><b>{t('data-lang-lbl-measurementperiod')}: </b> {
                                                                __KPIPeriods.find(x => x.key === itemComponentStructure.measurementPeriodId) !== undefined ?
                                                                    t(__KPIPeriods.find(x => x.key === itemComponentStructure.measurementPeriodId).text) :
                                                                    t('data-lang-nodata')
                                                            }</div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                { controlMain } 
                                            </Row>
                                            
                                        </div>
                                    </div>
                        }
                    }                
                ] : [] }
                enableExport={ false }
            />
            {
               (selectedDataserieToPanel !== null && calendarType !== null) &&
                <>
                    <SidePanelViewDataserieVariableValue
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_SetterIsPanelOpen={setIsViewDataserieVariableValuePanelOpen}
                        inputParam_ElementType={calendarType}
                        inputParam_SetCalendarType={setCalendarType}
                        inputParam_IsPanelOpen={isViewDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />
                    <SidePanelAddDataserieVariableValue
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_SetterIsPanelOpen={setIsAddDataserieVariableValuePanelOpen}
                        inputParam_ElementType={calendarType}
                        inputParam_SetCalendarType={setCalendarType}
                        inputParam_IsPanelOpen={isAddDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />
                    <SidePanelEditDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setIsEditDataserieVariableValuePanelOpen}
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_ElementType={calendarType}
                        inputParam_IsPanelOpen={isEditDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />
                    <SidePanelDeleteDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setIsDeleteDataserieVariableValuePanelOpen}
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_ElementType={calendarType}
                        inputParam_IsPanelOpen={isDeleteDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />                    
                </>
            }
            {
                selectedDataserieToPanel !== null && isCloseDataseriesPanelOpen &&
                <SidePanelDataserieClose
                    inputParam_BoardId={inputParam_BoardId}
                    inputParam_ElementId={inputParam_ElementId}
                    inputParam_DataSerieList={[selectedDataserieToPanel]}
                    inputParam_IsPanelOpen={isCloseDataseriesPanelOpen}
                    inputParam_SetterIsPanelOpen={setIsCloseDataseriesPanelOpen}
                />
            }
            {
                selectedDataserieToPanel !== null && isViewDataserieInfoPanelOpen &&
                <SidePanelViewDataserieAditionalInfo
                    inputParam_SetterIsPanelOpen={setIsViewDataserieInfoPanelOpen}
                    inputParam_IsPanelOpen={isViewDataserieInfoPanelOpen}
                    inputParam_DataSerie={selectedDataserieToPanel}
                    inputParam_SetterDataSerie={setSelectedDataserieToPanel}
                    inputParam_BoardId={inputParam_BoardId}
                />
            }
        </>
    );
}

BoardList.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_SetterComponentList: PropTypes.func,
    inputParam_ContainerComponent: PropTypes.object.isRequired,
};

export default BoardList;